import React from "react"
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import { Carousel, message, Spin } from "antd"
import './index.css'
import { connect } from "react-redux"
import swal from '@sweetalert/with-react'
import * as actionCreators from './store/actionCreators'
// import { login, logout } from '../../service/loginaction'
import { login, logout } from '../../service/loginaction_yunguan'
import Logo from "../Header/images/logo.png";
import { transformtime } from "../../utils/tools";
import Axios from "axios";
import Navigator from "../Navigator";
import Header1 from "../Header/Header1";
// import Home from "../Pages/Home";
import loginBack from './images/login-bc.png'
import logo from './images/logo.png'
import weibo from './images/weibo.png'
import wechat from './images/wechat.png'
import QQ from './images/qq.png'
import HomeHearder from '../Pages/Home/NewHome/HomeHearder';

/**
 * 获取新闻
 * @param page
 * @param limit
 * @returns {Promise<unknown>}
 */
// var getnews = async (page, limit) => {
//     return new Promise((resolve, reject) => {
//         Axios.get(`${global.url.news}/news/getNews/${limit}/${page}`)
//             .then(res => {
//                 resolve(res.data.payload)
//             })
//     })

// };
// var card2moving = false;
// const czpoint = [{x: 235, y: 291, name: '西北综合应用试验场'},
//                  {x: 608, y: 220, name: '东北综合应用试验场'},
//                  {x: 822, y: 165, name: '华北综合应用试验场'},
//                  {x: 602, y: 409, name: '华中综合应用试验场'},
//                  {x: 282, y: 452, name: '西南综合应用试验场'},
//                  {x: 554, y: 580, name: '华南综合应用试验场'},];

class UserLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            news: [],//新闻
            card2: [
                {
                    url: require('./images/img 2.png'),
                    index: 0,
                    id: 0
                },
                {
                    url: require('./images/img 3.png'),
                    index: 1,
                    id: 1
                },
                {
                    url: require('./images/img 4.png'),
                    index: 2,
                    id: 2
                },
            ],

            // weixinLoginFlag: false,
            isLogining: false,//是否处在登录状态
            isSpinWrapDisplay: 'none',//是否显示加载的状态容器
        }
        this.userRef = React.createRef();
        this.pwdRef = React.createRef();
    }
    // changecard2 = (e) => {
    //     if (e) {
    //         e.preventDefault && e.preventDefault();
    //         e.stopPropagation && e.stopPropagation();
    //         e.returnValue = false;
    //     }
    //     if (card2moving) return;
    //     let { card2 } = this.state;
    //     card2moving = true;
    //     let c1; // 当前第一个  也就是 index为0 的那个
    //     for (var i = 0; i < card2.length; i++) {
    //         card2[i].index--
    //         if (card2[i].index < 0) {
    //             c1 = card2[i]
    //             // c1.index = card2.length - 1
    //         }
    //     }

    //     this.setState(card2);
    //     setTimeout(() => {

    //         c1.index = card2.length - 1
    //         this.setState(card2)

    //         card2moving = false
    //     }, 100);
    // }
    // cardhover = () => {

    // }

    // 点击登录触发 "登陆请求"
    userLogin = async () => {
        // debugger
        // console.log(this.userRef.current.value,this.pwdRef.current.value)
        if (this.userRef.current.value === "") {
            message.warn("用户名不能为空！")
            this.userRef.current.focus()
            return
        }
        if (this.pwdRef.current.value === "") {
            message.warn("密码不能为空！")
            this.pwdRef.current.focus()
            return
        }
        this.setState({
            isLogining: true
        }, async () => {
            await this.props.login(this.userRef.current.value, this.pwdRef.current.value)
            this.setState({
                isLogining: false
            })
        })
        // await this.changeSpinStatus()
    }
    // 处理密码的"眼睛"是否打开
    handleShowPwd = (event) => {
        if (event.target.className === "UserLogin-right-area-input-close") {
            event.target.className = "UserLogin-right-area-input-open"
            event.target.previousElementSibling.type = "text"

        } else {
            event.target.className = "UserLogin-right-area-input-close"
            event.target.previousElementSibling.type = "password"
        }
    }

    // async componentDidMount() {
    //     setInterval(this.changecard2, 3000);
    //     let news = await getnews(1, 3);
    //     this.setState({news:news});
    // }
    // componentDidUpdate(preProps, preState) {
    //     if (preProps.loginObj.login !== this.props.loginObj.login) {
    //         let status = preProps.loginObj.login
    //       this.changeSpinStatus(status)
    //     }
    //   }

    /**
     * @description: 修改登录加载中按钮的状态
     * @event: changeSpinStatus   状态有问题，搞不定了
     * @return {*}
     */
    changeSpinStatus = () => {
        this.setState({
            isLogining: false
        })
        // let status = this.props.loginObj.login
        // console.log('changeSpinStatus', this.props.loginObj.login)
        // if (status) {
        //     this.setState({
        //         isLogining: false,
        //         isSpinWrapDisplay: 'none'
        //     })
        // } else {
        //     this.setState({
        //         isLogining: true,
        //         isSpinWrapDisplay: 'flex'
        //     }, () => {
        //         var spinTimeOut = setTimeout(() => {
        //             this.setState({
        //                 isLogining: false,
        //                 isSpinWrapDisplay: 'none'
        //             })
        //             message.error("登录失败，请重试！")
        //             clearTimeout(spinTimeOut)
        //         }, 5000)
        //     })
        // }
    }
    render() {
        const { isSpinWrapDisplay } = this.state;
        console.log(this.props.loginObj)
        if (!this.props.loginObj || !this.props.loginObj.login || this.props.loginObj.token === undefined) {
            return (
                <React.Fragment>
                    {/*主要内容*/}
                    <div className="UserLogin-bg">
                        {/*<Header1 style={{position:'static'}}/>*/}

                        <HomeHearder />
                        <img className='FirstPage_Background' src={loginBack} />


                        {/* <div className="UserLogin">
                            <content className="UserLogin-content">
                                <header className="UserLogin-content-header">
                                    用户登录
                                    <Link to='/home'>
                                        <div className="UserLogin-close">X</div>
                                    </Link>
                                </header>
                                <section className="UserLogin-selction">
                                    <div className="UserLogin-content-label">
                                        用户名
                                        <i className="UserLogin-content-icon">*</i>
                                    </div>
                                    <div className="UserLogin-input">
                                        <div className="UserLogin-content-border">
                                            <input type="text" className="UserLogin-content-input" placeholder="请输入您的用户名" ref={this.userRef} />
                                        </div>
                                        <p style={{ marginLeft: "6px", color: "#EE6060", fontSize: "14px", display: "none" }}>用户名错误</p>
                                    </div>
                                </section>
                                <section className="UserLogin-selction">
                                    <div className="UserLogin-content-label">
                                        密码
                                        <i className="UserLogin-content-icon">*</i>
                                    </div>
                                    <div className="UserLogin-input">
                                        <div className="UserLogin-content-border">
                                            <input type="password" className="UserLogin-content-input" placeholder="6-16个字符，包含数字和字母" ref={this.pwdRef} />
                                            <i className="UserLogin-content-input-close" onClick={this.handleShowPwd} />
                                            <Link to='/ResetPwd'>
                                                <p className="UserLogin-content-input-forget">
                                                    忘记密码
                                                </p>
                                            </Link>
                                        </div>

                                        <p style={{ marginLeft: "6px", color: "#EE6060", fontSize: "14px", display: "none" }}>密码错误</p>
                                    </div>
                                </section>
                                <div style={{ overflow: "hidden" }}>
                                    <section className="UserLogin-selction-submit">
                                        <div className="UserLogin-selction-submit-button" onClick={this.userLogin}>
                                            登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
                                        </div>
                                        <p className="UserLogin-selction-submit-other">
                                            或&nbsp;没有账号，请&nbsp;
                                            <Link to='/UserRegister'>
                                                <span className="UserLogin-selction-submit-register">注册</span>
                                            </Link>
                                        </p>
                                    </section>
                                    <section className="UserLogin-selction-thirdpart">
                                        <p className="UserLogin-selction-thirdpart-desc">第三方登录</p>
                                        <section className="UserLogin-selction-thirdpart-icons">
                                            <i className="qq-icon" />
                                            <i className="weixin-icon" />
                                            <i className="weibo-icon" />
                                        </section>
                                    </section>
                                </div>
                            </content>
                        </div> */}
                        <div className="UserLogin">
                            <div className="UserLogin-spin-wrap" style={this.state.isLogining ? { display: 'flex' } : { display: 'none' }}>
                                <Spin size="large" tip="登录中..." spinning={this.state.isLogining}></Spin>
                            </div>
                            <div className="userLogin-left-area">
                                <div className="userLogin-left-area-logo-wrap">
                                    <img src={logo} className="userLogin-left-area-logo"></img>
                                </div>
                                <div className="userLogin-left-area-name-area">
                                    <div className="userLogin-left-area-chineseName">陆地观测卫星共性应用支撑平台</div>
                                    <div className="userLogin-left-area-englishName">Common application support platform for land observation satellite</div>
                                </div>
                            </div>
                            <div className="userLogin-right-area">
                                <Link to='/home'>
                                    <div className="UserLogin-right-area-close-button">X</div>
                                </Link>
                                <div className="UserLogin-right-area-operate-wrap">
                                    <div className="UserLogin-right-area-header">登录</div>
                                    <input type="text" className="UserLogin-right-area-username-input" placeholder="注册邮箱或昵称" ref={this.userRef} />
                                    <div className="UserLogin-right-area-password-input-wrap">
                                        <input type="password" className="UserLogin-right-area-password-input" placeholder="密码" ref={this.pwdRef} />
                                        <i className="UserLogin-right-area-input-close" onClick={this.handleShowPwd} />
                                    </div>
                                    <div className="UserLogin-right-area-login-button" onClick={this.userLogin}>登录</div>
                                    <div className="UserLogin-right-area-forget-password-area">
                                        <Link to='/ResetPwd'>
                                            <div className="UserLogin-right-area-forget-password-button">忘记密码</div>
                                        </Link>
                                        <Link to='/UserRegister'>
                                            <div className="UserLogin-right-area-register-button">注册</div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="UserLogin-right-area-third-party-login-area">
                                    <div className="UserLogin-right-area-third-party-login-tips">第三方登录</div>
                                    <div className="UserLogin-right-area-third-party-login-logo-wrap">
                                        <img src={weibo} className="UserLogin-right-area-third-party-login-weibo"></img>
                                        <img src={wechat} className="UserLogin-right-area-third-party-login-wechat"></img>
                                        <img src={QQ} className="UserLogin-right-area-third-party-login-QQ"></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* {weixinLoginFlag &&
                        <div className="weixin_main" id="weixin_main">

                        </div>
                    } */}
                    {/*<Navigator/>*/}
                </React.Fragment>
            )
        } else {
            //记录目标页
            let to;
            if (this.props.location.state != null) {
                to = this.props.location.state.to;
            }
            const urlTo = to || '/Guide';
            return <Redirect path='/Login' to={urlTo} />
        }
    }

    // openWeixinLogin = () => {
    //     this.setState({ weixinLoginFlag: true }, () => {
    //         var obj = new global.WxLogin({
    //             // self_redirect: true,
    //             id: "weixin_main",
    //             appid: "",
    //             scope: "snsapi_login",
    //             // redirect_uri: `http://${global.ip}`,
    //             redirect_uri: `http://localhost:3001/`,
    //             // state: "",
    //             // style: "",
    //             // href: ""
    //         });
    //         console.log("openWeixinLogin",obj);
    //     });
    // }
}

/**
 * redux
 * @param state
 * @returns {{user: *, loginObj: *}}
 */
const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    // user: state.userReducer.get('user').toJS()
    user: state.userReducer.get('user').toJS()

})
const mapDispatch = (dispatch) => ({
    login: async (userName, password) => {
        if (userName === '' || password === '') {
            swal({
                title: "请输入账号密码",
                text: "",
                icon: "error",
                closeOnClickOutside: false,
            });
        } else {
            //z这里调用登陆接口 
            //先写个假的---------------------------------------
            // actionCreators.checkaccount(userName, password).then((data) => {
            //     dispatch({ type: 'login', userName:userName, userId: data.userid, token: data.token })
            // }).catch(
            //     () => {
            //         swal({
            //             title: '登录失败',
            //             text: '',
            //             icon: "error",
            //             closeOnClickOutside: false
            //         })
            //     }
            // )

            await dispatch(login({ userName: userName, password: password }))
            //-------------------------------------------------
        }
    }
})
export default connect(mapState, mapDispatch)(UserLogin)
